import { apiService } from './apiService';
import { getFixtureDateRange, toUTCDate } from '../helpers/dateUtils';

// Shared loader for the public fixture-landing feed.
//
// CorporateHeader renders on every corporate page and its mobile drawer lists the
// leagues playing this week, which is the same unfiltered window the landing page
// already asks for. Caching the promise at module scope means the two share one
// request when they're on the same page, and the drawer opens instantly on the
// landing page because the feed is already resolved.
let pending = null;

export const getLandingFixtures = () => {
    if (pending) return pending;

    const dateFrom = toUTCDate(new Date()).toISOString().slice(0, 10);
    const { dateTo } = getFixtureDateRange();

    pending = apiService
        .apiGet(`${import.meta.env.VITE_API_URL}/fixture-landing-list?date_from=${dateFrom}&date_to=${dateTo}`)
        .then((data) => (Array.isArray(data?.fixtures) ? data.fixtures : []))
        .catch((error) => {
            // Don't poison the cache — a later caller (e.g. re-opening the drawer)
            // should be able to retry rather than replay the failure forever.
            pending = null;
            throw error;
        });

    return pending;
};
